import { render } from "./DynamicBreadCrumb.vue?vue&type=template&id=2e2c73ce&scoped=true&ts=true"
import script from "./DynamicBreadCrumb.vue?vue&type=script&lang=ts"
export * from "./DynamicBreadCrumb.vue?vue&type=script&lang=ts"

import "./DynamicBreadCrumb.vue?vue&type=style&index=0&id=2e2c73ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2c73ce"]])

export default __exports__